import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@core/app";
import "@core/theme/tokens.css";

const container = document.getElementById("root");
if (container === null) throw new Error("index.html is missing its #root element");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
